@if (topArticles.length || recommendedArticles.length || popularArticles.length) {
<div class="recommendations-preview row mx-0 flex-nowrap">

  <!-- TOP PRODUCTS -->
  <div class="col-12 col-md-4 px-0">
    <div class="rp-section">
      <div class="rp-header">
        <span class="rp-icon-circle" style="background:#000">
          <i class="material-icons">stars</i>
        </span>
        <h3 class="mb-0">{{ "TOP_PRODUCTS" | translate }}</h3>
      </div>

      @if (topArticles.length) {
        <div class="rp-carousel">
          <app-article-card
            [article]="topArticles[topIndex]"
            (showArticleDetails)="showArticleDetails(topArticles[topIndex])"
            [hideMatrix]="true"
            class="rp-card"
          >
            @if (isPreviouslyBought(topArticles[topIndex])) {
            <div class="d-flex justify-content-end mt-1 pe-1" badge>
              <app-previously-bought-badge></app-previously-bought-badge>
            </div>
          }
        </app-article-card>

        

          @if (topArticles.length > 1) {
            <div class="rp-nav">
              <button class="rp-nav-btn" (click)="prev('top')" aria-label="Previous">
                <i class="material-icons">chevron_left</i>
              </button>
              <span class="rp-dots">
                @for (a of topArticles; track a; let i = $index) {
                  <span class="rp-dot" [class.active]="i === topIndex"></span>
                }
              </span>
              <button class="rp-nav-btn" (click)="next('top')" aria-label="Next">
                <i class="material-icons">chevron_right</i>
              </button>
            </div>
          }
        </div>
      } @else {
        <div class="rp-empty">{{ "NO_RECOMMENDATIONS_AVAILABLE" | translate }}</div>
      }
    </div>
  </div>

  <!-- RECOMMENDED -->
  <div class="col-12 col-md-4 px-0">
    <div class="rp-section">
      <div class="rp-header">
        <span class="rp-icon-circle" style="background:#000">
          <img src="assets/images/recommended.svg" alt="" style="width:16px;height:16px;filter:brightness(0) invert(1)">
        </span>
        <h3 class="mb-0">{{ "RECOMMENDED_PRODUCTS" | translate }}</h3>
      </div>

      @if (recommendedArticles.length) {
        <div class="rp-carousel">
          <app-article-card
            [article]="recommendedArticles[recommendedIndex]"
            (showArticleDetails)="showArticleDetails(recommendedArticles[recommendedIndex])"
            [hideMatrix]="true"
            class="rp-card"
          >
          @if (isPreviouslyBought(recommendedArticles[recommendedIndex])) {
            <div class="d-flex justify-content-end mt-1 pe-1" badge>
              <app-previously-bought-badge></app-previously-bought-badge>
            </div>
          }
        </app-article-card>

         

          @if (recommendedArticles.length > 1) {
            <div class="rp-nav">
              <button class="rp-nav-btn" (click)="prev('recommended')" aria-label="Previous">
                <i class="material-icons">chevron_left</i>
              </button>
              <span class="rp-dots">
                @for (a of recommendedArticles; track a; let i = $index) {
                  <span class="rp-dot" [class.active]="i === recommendedIndex"></span>
                }
              </span>
              <button class="rp-nav-btn" (click)="next('recommended')" aria-label="Next">
                <i class="material-icons">chevron_right</i>
              </button>
            </div>
          }
        </div>
      } @else {
        <div class="rp-empty">{{ "NO_RECOMMENDATIONS_AVAILABLE" | translate }}</div>
      }
    </div>
  </div>

  <!-- POPULAR -->
  <div class="col-12 col-md-4 px-0">
    <div class="rp-section">
      <div class="rp-header">
        <span class="rp-icon-circle" style="background:#000">
          <img src="assets/images/popular.svg" alt="" style="width:16px;height:16px;filter:brightness(0) invert(1)">
        </span>
        <h3 class="mb-0">{{ "POPULAR_PRODUCTS" | translate }}</h3>
      </div>

      @if (popularArticles.length) {
        <div class="rp-carousel">
          <app-article-card
            [article]="popularArticles[popularIndex]"
            (showArticleDetails)="showArticleDetails(popularArticles[popularIndex])"
            [hideMatrix]="true"
            class="rp-card"
          >
           @if (isPreviouslyBought(popularArticles[popularIndex])) {
            <div class="d-flex justify-content-end mt-1" badge>
              <app-previously-bought-badge></app-previously-bought-badge>
            </div>
          }
          </app-article-card>

         

          @if (popularArticles.length > 1) {
            <div class="rp-nav">
              <button class="rp-nav-btn" (click)="prev('popular')" aria-label="Previous">
                <i class="material-icons">chevron_left</i>
              </button>
              <span class="rp-dots">
                @for (a of popularArticles; track a; let i = $index) {
                  <span class="rp-dot" [class.active]="i === popularIndex"></span>
                }
              </span>
              <button class="rp-nav-btn" (click)="next('popular')" aria-label="Next">
                <i class="material-icons">chevron_right</i>
              </button>
            </div>
          }
        </div>
      } @else {
        <div class="rp-empty">{{ "NO_RECOMMENDATIONS_AVAILABLE" | translate }}</div>
      }
    </div>
  </div>

</div>
}
